import { Inject, Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { Router } from '@angular/router';

// export const IGNORE_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private authService;
  private toast;

  constructor(@Inject(Injector) private readonly injector: Injector, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // MC GPO-130 Se obtienen los servicios de esta manera para evitar un error de dependencia circular
    setTimeout(() => {
      this.toast = this.injector.get(ToastrService);
      this.authService = this.injector.get(AuthService);
    });

    if (request.url.includes('login')) {
      return next.handle(request);
    }

    if (request.headers.has('X-Skip-Error-Handler')) {
      const modifiedReq = request.clone({
        headers: request.headers.delete('X-Skip-Error-Handler')
      });
      return next.handle(modifiedReq);
    }
    
    return next.handle(request)
      .pipe(
        catchError(((error: any) => {
          if (error.error?.errors) {
            console.log(error);
            this.toast.error(error.error.errors[0], error.error.message, { timeOut: 10000 });
            // throw 'Error API SINERGIAL'
            return throwError(error);
          } else {
            console.log(error);
            if (error.status == 401 || error.status == 403) {
              // this.toast.error("Error de autenticación", null, { timeOut: 10000 });
              this.authService.logout();
              document.location.reload();
              // throw 'Error AUTENTICACION';
              return throwError(error);
            } else {
              this.toast.error("Error Interno: " + error.status, null, { timeOut: 10000 });
              // throw 'Error';
              return throwError(error);
            }

          }
        }))
      )
  }
}
